import { PromoConfig, PromoTemplateType } from '../types';

export const DEFAULT_PROMO_CONFIG: PromoConfig = {
    enabled: true,
    position: 'bottom-left',
    size: 'normal',
    targetAudience: 'all',
    template: 'gold_gift_10min',
    title: "Félicitations !",
    subtitle: "Bénéficiez d'une consultation de voyance privée offerte avec un expert.",
    badgeText: "10 Min Offertes",
    giftHighlight: "10 Minutes Gratuites",
    ctaText: "Réclamer mon Cadeau (10 Min)",
    ctaAction: 'open_form',
    imageUrl: "/sarah.jpg",
    displayDelaySeconds: 4,
    repeatIntervalMinutes: 5,
    startMinimized: false,
    gradientTheme: 'gold'
};

export interface PromoTemplatePreset {
    id: PromoTemplateType;
    name: string;
    description: string;
    icon: string;
    config: Partial<PromoConfig>;
}

export const PROMO_TEMPLATE_PRESETS: PromoTemplatePreset[] = [
    {
        id: 'gold_gift_10min',
        name: "10 Minutes Offertes (Bienvenue VIP)",
        description: "Offre d'accueil avec formulaire rapide pour capter de nouveaux prospects.",
        icon: "GiftIcon",
        config: {
            template: 'gold_gift_10min',
            title: "Félicitations !",
            subtitle: "Bénéficiez d'une consultation de voyance privée offerte avec un expert.",
            badgeText: "10 Min Offertes",
            giftHighlight: "10 Minutes Gratuites",
            ctaText: "Réclamer mon Cadeau (10 Min)",
            ctaAction: 'open_form',
            gradientTheme: 'gold',
            targetAudience: 'guests_only'
        }
    },
    {
        id: 'pack_vip_flash',
        name: "Vente Flash Forfaits Voyance (50€ & 100€)",
        description: "Mise en avant des packs de minutes privées sans surtaxe valables à vie.",
        icon: "CrownIcon",
        config: {
            template: 'pack_vip_flash',
            title: "Vente Flash Privilège !",
            subtitle: "Profitez de nos tarifs exclusifs sur les Forfaits Or & Prestige (Minutes valables à vie).",
            badgeText: "Top Forfait",
            giftHighlight: "Jusqu'à 300 Min Incluses",
            ctaText: "Découvrir les Forfaits Flash",
            ctaAction: 'open_premium',
            gradientTheme: 'purple',
            targetAudience: 'all'
        }
    },
    {
        id: 'love_return',
        name: "Retour Affectif & Destin Amoureux",
        description: "Ciblage sentimental avec invitation directe au secrétariat privé de Sarah.",
        icon: "HeartIcon",
        config: {
            template: 'love_return',
            title: "Votre Destin Amoureux",
            subtitle: "Des doutes sur ses sentiments ou son retour ? Nos experts sentimentaux vous répondent.",
            badgeText: "Flash Amour",
            giftHighlight: "Révélations de Couple",
            ctaText: "Consulter Sarah en Direct",
            ctaAction: 'open_sarah',
            gradientTheme: 'crimson',
            targetAudience: 'all'
        }
    },
    {
        id: 'tarot_instant',
        name: "🃏 Tirage de Tarot de Marseille Immédiat",
        description: "Incitation au tirage interactif des cartes divinatoires en direct.",
        icon: "SparklesIcon",
        config: {
            template: 'tarot_instant',
            title: "Les Cartes ont un Message",
            subtitle: "Tirez vos 3 arcanes majeurs du Tarot de Marseille et découvrez votre avenir.",
            badgeText: "Tarot Immédiat",
            giftHighlight: "3 Arcanes Divinatoires",
            ctaText: "Faire mon Tirage Gratuit",
            ctaAction: 'open_tarot',
            gradientTheme: 'night',
            targetAudience: 'all'
        }
    },
    {
        id: 'horoscope_reveal',
        name: "Révélation Astrale & Transition Lunaire",
        description: "Alerte astrologique dynamique pour fidéliser les membres inscrits.",
        icon: "StarIcon",
        config: {
            template: 'horoscope_reveal',
            title: "Alignement Astral Majeur",
            subtitle: "Une conjonction planétaire exceptionnelle traverse votre ciel astral en ce moment.",
            badgeText: "Alerte Zodiaque",
            giftHighlight: "Guidance Personnalisée",
            ctaText: "Échanger avec un Astrologue",
            ctaAction: 'open_sarah',
            gradientTheme: 'emerald',
            targetAudience: 'registered_only'
        }
    }
];